<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.maintenance.workshops', { value: 'default' })"></portal-title>
      <portal-breadcumb :text="text"></portal-breadcumb>
      <div class="geo-content">
        <l-map
          style="height: 100%"
          :zoom="zoom"
          :center="center"
          :options="{ zoomControl: false }"
        >
          <l-tile-layer :url="url"></l-tile-layer>
          <l-circle-marker
            v-for="(poi, idx) in poiList"
            :key="idx"
            :lat-lng="latLng(poi)"
            :radius="6"
            :color="gColor"
            :fill=true
            :fillColor="gColor"
            :fillOpacity=1
          >
            <l-tooltip class="tooltip">{{poi.poiname}} <br/> 
            <h3>{{poi.city}}</h3>
            </l-tooltip>
          </l-circle-marker>
          <l-control-zoom position="topright"></l-control-zoom>
        </l-map>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LTooltip,
  LControlZoom,
} from "vue2-leaflet";
import CoreService from '@/services/CoreService'

export default {
   title: "Maintenance workshops" ,
  methods: {
    loadPoi(){
      CoreService.findAll().then(response => {
        this.poiList = response.data
      })
    },
    latLng(poi){
      return [poi.latitude, poi.longitude]
    }
  },
  mounted() {
    this.loadPoi()
  },
  name: "PoiPage",
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    LMap,
    LTileLayer,
    LCircleMarker,
    LTooltip,
    LControlZoom,
  },
  data: () => ({
    poiList:[],
    text: "Acceuil > Mon planning > Atelier de maintenance",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    zoom: 5,
    yColor: "#EEBB07",
    gColor: "#6DB7A2",
    center: [47.31322, 5.19482],
  }),
};
</script>

<style scoped>
.tooltip{
  color: #00475A;
  font-size: 14px;
  font-family: Calibri;
  margin: 0px;
  padding: 10px;
}
</style>